import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, Row } from "react-bootstrap";
import { apiRoutes } from "../../../hooks/apiClient";
import PaginatedView from "../../../components/UI/PaginatedView/PaginatedView";
import SelectInput from "../../../components/UI/SelectInput/SelectInput";
import TextInputFormik from "../../../components/UI/TextInput/TextInputFormik";
import funcionalidades from "../../../context/AuthContext.funcionalidades";
import SelectSiglaAtividade from "../../../components/UI/SelectInput/SelectSiglaAtividadeFormik";
import SelectRoteiroAtividade from "../../../components/UI/SelectInput/SelectRoteiroAtividadeFormik";
import SelectFaseAtividade from "../../../components/UI/SelectInput/SelectFaseAtividadeFormik";
import Strings2HtmlListItems from "../../../components/Formatters/Strings2HtmlListItems";

const columns = [
  {
    name: "Sigla",
    selector: "sigla",
    maxWidth: "10%",
    sortable: true,
  },
  {
    name: "Nome",
    selector: "nome",
    maxWidth: "40%",
    sortable: true,
  },
  {
    name: "Situação",
    selector: "statusSituacao",
    maxWidth: "10%",
    center: true,
  },
  {
    name: "Roteiro",
    selector: "nomeRoteiro",
    width: "20%",
    sortable: true,
    cell: (row) => <Strings2HtmlListItems value={row.nomeRoteiro} separator="|" />,
  },
  {
    name: "Fase",
    selector: "nomeSintese",
    width: "10%",
  },
];

const validationSchema = Yup.object().shape({
  status: Yup.string().default(""),
  sigla: Yup.string().default(""),
  nome: Yup.string().default(""),
  sequencialRoteiro: Yup.string().default(""),
  sequencialFase: Yup.string().default(""),
});

const initialValues = {};
validationSchema._nodes.forEach((key) => {
  initialValues[key] = "";
});

const ConsultaAtividadePadrao = ({ history, match }) => {
  const formik = useFormik({
    initialValues,
    validationSchema,
  });

  return (
    <PaginatedView
      title="Atividades"
      keyField="sequencialAtividade"
      descriptionField="nome"
      defaultSearch
      defaultSearchPlaceholder="Digite a atividade"
      queryService={apiRoutes.fiscalizacao.parametrizacao.consultaAtividadePadrao}
      deleteService={apiRoutes.fiscalizacao.parametrizacao.excluiAtividadePadrao}
      advancedSearchFormik={formik}
      editRoute={`${match.url}/form`}
      columns={columns}
      permissionDelete={funcionalidades.atividadePadrao.deletar}
      permissionInsert={funcionalidades.atividadePadrao.inserir}
      history={history}
      reduxKey="atividades"
    >
      <Row>
        <Form.Group as={Col} sm={12} md={6}>
          <Form.Label>Status</Form.Label>
          <SelectInput
            formik={formik}
            field="status"
            options={[
              { key: "T", value: "T", text: "Todos" },
              { value: "A", text: "Ativos" },
              { value: "I", text: "Inativos" },
            ]}
          />
        </Form.Group>
        <Form.Group as={Col} sm={12} md={6}>
          <Form.Label>Sigla</Form.Label>
          <SelectSiglaAtividade formik={formik} field="sigla" />
        </Form.Group>
        <Form.Group as={Col} sm={12} md={6}>
          <Form.Label>Nome</Form.Label>
          <TextInputFormik formik={formik} field="nome" />
        </Form.Group>
        <Form.Group as={Col} sm={12} md={6}>
          <Form.Label>Roteiro</Form.Label>
          <SelectRoteiroAtividade formik={formik} field="sequencialRoteiro" />
        </Form.Group>
        <Form.Group as={Col} sm={12} md={6}>
          <Form.Label>Fase</Form.Label>
          <SelectFaseAtividade formik={formik} field="sequencialFase" />
        </Form.Group>
      </Row>
    </PaginatedView>
  );
};

export default ConsultaAtividadePadrao;
